module.exports = __webpack_public_path__ + "static/media/unique-funeral-home.be6ea0dd.svg";